import React from 'react';
import { Box, Paper, Title } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import DebouncedInput from './DebouncedInput';
import When from './When';

type Props = {
    searchPlaceholder?: string;
    children: React.ReactNode | JSX.Element;
    buttons?: React.ReactNode;
    onSearchChange?: (value: string) => void;
    searchValue?: string;
    title?: string;
    tableHeightOffset?: string;
    headerPadding?: string;
    pagination?: React.ReactNode;
    borderRadius?: string;

    detachedBody?: boolean;
};

function TableWrapper({
    children,
    buttons,
    searchPlaceholder,
    searchValue,
    onSearchChange,
    title,
    tableHeightOffset = '275px',
    headerPadding = 'p-6',
    pagination,
    borderRadius = 'rounded-xl rounded-tl-none',
    detachedBody = false,
}: Props) {
    const onSearch = (value: string) => {
        if (onSearchChange) {
            onSearchChange(value);
        }
    };

    const chrome = (
        <div className={`w-full flex flex-col ${headerPadding}`}>
            <When condition={!!title}>
                <Title order={3} className="text-primary mb-2">
                    {title}
                </Title>
            </When>
            <div className="flex w-full flex-row items-center justify-between">
                <When condition={!!onSearchChange}>
                    <DebouncedInput
                        leftSection={<IconSearch />}
                        placeholder={searchPlaceholder || 'Search list'}
                        value={searchValue}
                        onChange={event => onSearch(event.target.value)}
                        className="mr-auto w-1/3"
                    />
                </When>
                {buttons}
            </div>
        </div>
    );

    return (
        <>
            <When condition={detachedBody}>
                <Box
                    w="100%"
                    className="flex min-h-0 flex-col gap-4 overflow-hidden"
                    style={{
                        height: `calc(100vh - ${tableHeightOffset})`,
                    }}
                >
                    <Paper
                        shadow="md"
                        className={`${borderRadius} shrink-0 bg-white`}
                        w="100%"
                    >
                        {chrome}
                    </Paper>
                    <Box className="min-h-0 flex-1 overflow-auto">
                        {children}
                    </Box>
                </Box>
            </When>
            <When condition={!detachedBody}>
                <div className="w-full">
                    <div
                        style={{
                            height: `calc(100vh - ${tableHeightOffset})`,
                        }}
                        className={`w-full bg-white shadow-md ${borderRadius} flex flex-col`}
                    >
                        {chrome}
                        <div className="flex-1 min-h-0 px-6 flex flex-col">
                            <div className="flex-1 min-h-0 overflow-auto">
                                {children}
                            </div>
                            <When condition={!!pagination}>
                                <div className="flex justify-end py-2">
                                    {pagination}
                                </div>
                            </When>
                        </div>
                    </div>
                </div>
            </When>
        </>
    );
}

export default TableWrapper;
